
export default function Testimonials() {
  const testimonials = [
    {
      name: 'María G.',
      text: 'El Dr. Delgadillo me acompañó durante todo mi embarazo. Su trato es excepcional y siempre me sentí en las mejores manos. Gracias a él, mi experiencia fue maravillosa.',
      rating: 5
    },
    {
      name: 'Ana L.',
      text: 'Después de años de buscar un ginecólogo que me escuchara, encontré al Dr. Delgadillo. Es empático, profesional y siempre se toma el tiempo para explicar todo con claridad.',
      rating: 5
    },
    {
      name: 'Carmen R.',
      text: 'La atención es excelente desde que llegas al consultorio. El doctor es muy profesional y te hace sentir cómoda en todo momento. Lo recomiendo ampliamente.',
      rating: 5
    },
    {
      name: 'Laura M.',
      text: 'Estoy muy agradecida con el Dr. Delgadillo por su atención durante mi tratamiento. Es un médico dedicado que realmente se preocupa por el bienestar de sus pacientes.',
      rating: 5
    },
    {
      name: 'Patricia S.',
      text: 'El consultorio es muy limpio y acogedor. El doctor siempre es puntual y te atiende con mucha paciencia. Me siento muy segura bajo su cuidado.',
      rating: 5
    },
    {
      name: 'Sofía V.',
      text: 'Excelente médico. Me ayudó a resolver mis dudas sobre planificación familiar con mucha profesionalidad y sin juzgar. Su trato humano marca la diferencia.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Opiniones de pacientes
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            La confianza de mis pacientes es mi mayor satisfacción
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-pink-400 to-blue-400 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-pink-50 to-blue-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-pink-100"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-pink-200 to-blue-200 flex items-center justify-center shadow-md">
                  <i className="ri-user-fill text-2xl text-gray-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-lg">{testimonial.name}</h4>
                  <div className="flex gap-1 mt-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}